

/**
 * BlitzBreadcrumb - Shows current position in the 2-level Blitz queue
 * (revised 2026-05-18 — the user-facing levels are `chapter` and `point`;
 * the legacy `L1` / `L2` tags are gone). Displays "Chapter Title" for a
 * chapter row and "Chapter Title > Key Point Title" for a point row.
 */
function BlitzBreadcrumb({ breadcrumb, level }) {
  // Get level badge color + human label.
  const getLevelColor = () => {
    switch (level) {
      case 'chapter':
        return 'bg-blue-600';
      case 'point':
        return 'bg-purple-600';
      default:
        return 'bg-gray-600';
    }
  };

  const getLevelLabel = () => {
    switch (level) {
      case 'chapter':
        return 'Chapter';
      case 'point':
        return 'Point';
      default:
        return level;
    }
  };

  return (
    <div className="flex items-center gap-2 text-sm">
      <span className={`px-2 py-0.5 rounded text-xs font-medium text-white ${getLevelColor()}`}>
        {getLevelLabel()}
      </span>
      <span className="text-gray-400">{breadcrumb}</span>
    </div>
  );
}

export default BlitzBreadcrumb;

